import { render, staticRenderFns } from "./delete_confirmation.vue?vue&type=template&id=510b8521&scoped=true&"
import script from "./delete_confirmation.vue?vue&type=script&lang=js&"
export * from "./delete_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b8521",
  null
  
)

export default component.exports